// extracted by mini-css-extract-plugin
export var editButton = "_q5-0";